import {Component} from '@angular/core';

@Component({
  selector: 'app-product-logo',
  standalone: true,
  templateUrl: './product-logo.component.html',
  styleUrls: ['./product-logo.component.scss']
})
export class ProductLogoComponent {
  constructor() {
  }
}
